import { render } from "./CmsPages.vue?vue&type=template&id=bb1b2414"
import script from "./CmsPages.vue?vue&type=script&lang=js"
export * from "./CmsPages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__